import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Paper, Box, TimelineItem, TimelineSeparator, TimelineConnector, TimelineDot, TimelineContent} from 'views/components';

const TimelineCard = (props) => {
  const {
    timeString,
    icon: Icon,
    iconColor,
    timeBg,
    title,
    children,
  } = props;

  return (
    <TimelineItem
      sx={{
        '&::before': {flex: 0, padding: 0},
        'marginLeft': 0,
        'width': '100%',
        'maxWidth': {xs: '100%', sm: '700px', md: '900px'},
        'boxSizing': 'border-box',
      }}
    >
      <TimelineSeparator>
        <TimelineDot sx={{backgroundColor: iconColor, border: 'none'}}>
          <Icon sx={{color: 'white'}} />
        </TimelineDot>
        <TimelineConnector/>
      </TimelineSeparator>
      <TimelineContent sx={{display: 'flex', alignItems: 'flex-start', width: '100%', maxWidth: '100%', boxSizing: 'border-box'}}>
        <Paper sx={{flexGrow: 1, width: '100%', maxWidth: '100%', boxSizing: 'border-box'}}>
          <Paper
            sx={{
              p: 1,
              backgroundColor: timeBg,
              boxShadow: 'none',
              width: '100%',
              maxWidth: '100%',
              boxSizing: 'border-box',
            }}
          >
            <Typography variant="caption" color="text.secondary">
              {timeString}
            </Typography>
          </Paper>
          <Box sx={{p: 2, width: '100%', maxWidth: '100%', boxSizing: 'border-box'}}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{mb: 1}}>
              {title}
            </Typography>
            <Box>
              {children}
            </Box>
          </Box>
        </Paper>
      </TimelineContent>
    </TimelineItem>
  );
};

TimelineCard.propTypes = {
  timeString: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  iconColor: PropTypes.string.isRequired,
  timeBg: PropTypes.string,
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default TimelineCard;
